import PageLayout from '@/components/feature/PageLayout';

export default function About() {
  return (
    <PageLayout>
      <section className="relative overflow-hidden min-h-screen bg-black">
        <div className="max-w-6xl mx-auto px-6 md:px-10 pt-6 md:pt-10 pb-16 md:pb-24 text-center">
          <h1 className="font-heading text-5xl md:text-7xl text-white leading-none text-center mx-auto px-4 max-w-full md:max-w-4xl">
            Bien plus qu'un métier, une véritable passion
          </h1>

          <div className="mt-[4.55rem] md:mt-[6.5rem] max-w-2xl mx-auto space-y-8">
            <div className="bg-white rounded-2xl p-8 md:p-10">
              <p className="text-gray-800 leading-normal tracking-wide text-lg md:text-xl text-left font-avenir">
                La recherche permanente de perfection fait partie de son ADN.
              </p>
              <p className="text-gray-800 leading-normal tracking-wide text-lg md:text-xl mt-4 text-left font-avenir">
                Romuald est animé par son esprit d'innovation et par l'envie d'aller toujours plus loin.<br /><br />Il explore sans cesse de nouvelles techniques et sélectionne les matériaux les plus avancés afin de donner vie à des réalisations toujours plus abouties et à votre image.
              </p>
              <p className="text-gray-800 leading-normal tracking-wide text-lg md:text-xl mt-4 text-left font-avenir">
                Cette même exigence nourrit sa créativité et l'amène à repousser sans cesse les limites de son art.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 md:p-10">
              <p className="text-gray-800 leading-normal tracking-wide text-lg md:text-xl text-left font-avenir">
                Le luxe ne réside pas dans l'excès.<br /><br />Il réside dans la perfection invisible, celle qui ne cherche pas à attirer le regard, mais qui s'impose naturellement par la précision d'un alignement, l'équilibre d'un volume, la justesse d'une finition ou l'harmonie d'un espace.
              </p>
            </div>

            <p className="text-white leading-relaxed text-xl md:text-2xl text-center pt-8 uppercase">
              Parce que l’excellence se construit aussi avec les meilleurs fabricants
            </p>


            <div className="bg-white rounded-2xl p-8 md:p-10">
              <div className="flex flex-wrap items-center justify-center gap-10 md:gap-16">
                <img
                  src="https://storage.readdy-site.link/project_files/a55b3f6a-c462-4da0-8e74-cf71c31de733/7d9474c0-ca95-4178-88a0-c13d82c5a808_compressed_Logo_Porcelanosa.webp"
                  alt="Porcelanosa"
                  className="h-8 md:h-10 w-auto object-contain"
                />
                <img
                  src="https://storage.readdy-site.link/project_files/a55b3f6a-c462-4da0-8e74-cf71c31de733/f4790cdb-c016-4024-8768-8c39e7ac18f8_schluter-systems.svg"
                  alt="Schlüter"
                  className="h-24 md:h-28 w-auto object-contain"
                />
                <img
                  src="https://storage.readdy-site.link/project_files/a55b3f6a-c462-4da0-8e74-cf71c31de733/28abfa50-40ad-4100-b6ad-15bb4accea33_logo-aubade.svg"
                  alt="Aubade"
                  className="h-8 md:h-10 w-auto object-contain"
                />
                <img
                  src="https://storage.readdy-site.link/project_files/a55b3f6a-c462-4da0-8e74-cf71c31de733/52ee9854-ec24-444a-96bb-408d5bc31540_compressed_Image-05-08-2026-a-20.30.webp"
                  alt="Kerakoll"
                  className="h-8 md:h-10 w-auto object-contain"
                />
                <img
                  src="https://storage.readdy-site.link/project_files/a55b3f6a-c462-4da0-8e74-cf71c31de733/a33b21dc-bba3-4a4d-a62e-d5ea05e5b38c_compressed_Image-05-08-2026-a-20.25.webp"
                  alt="Point.P"
                  className="h-10 md:h-14 w-auto object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
}